import GalleryFigure from "./GalleryFigure";

export default GalleryFigure;